import { useState } from "react";
import { CheckCircle2, ArrowRight, Loader } from "lucide-react";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

export default function ComingSoon() {
  const [name, setName]           = useState("");
  const [email, setEmail]         = useState("");
  const [loading, setLoading]     = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]         = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/waitlist/join`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ name: name.trim(), email: email.trim().toLowerCase() })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Something went wrong");
      setSubmitted(true);
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      minHeight: "100vh", background: "#ffffff", display: "flex", flexDirection: "column"
    }}>

      {/* Top accent bar */}
      <div style={{ height: "6px", background: "linear-gradient(90deg, #1a3a6b 0%, #2ab4a0 100%)" }} />

      {/* Main */}
      <div style={{
        flex: 1, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "flex-start", padding: "64px 16px 80px"
      }}>
        <div style={{ width: "100%", maxWidth: "448px", textAlign: "center" }}>

          {/* Logo */}
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "40px" }}>
            <img
              src="/logo.png"
              alt="TheHealthHire.com"
              style={{ height: "88px", width: "auto", objectFit: "contain", maxWidth: "300px" }}
            />
          </div>

          {/* Coming Soon badge */}
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "8px",
            marginBottom: "24px", padding: "8px 16px", borderRadius: "9999px",
            border: "1px solid #2ab4a0", background: "#e6f7f5", color: "#1a3a6b"
          }}>
            <span style={{
              width: "8px", height: "8px", borderRadius: "50%",
              background: "#2ab4a0", display: "inline-block",
              animation: "ping 1.5s cubic-bezier(0,0,0.2,1) infinite"
            }} />
            <span style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
              Launching Soon
            </span>
          </div>

          {/* Headline */}
          <h1 style={{ color: "#1a3a6b", fontSize: "clamp(28px, 5vw, 40px)", fontWeight: 800,
            lineHeight: 1.2, marginBottom: "12px" }}>
            India's Healthcare<br />Job Portal
          </h1>
          <p style={{ color: "#718096", fontSize: "16px", lineHeight: 1.7, marginBottom: "36px", maxWidth: "360px", margin: "0 auto 36px" }}>
            Connecting doctors, nurses and healthcare professionals with top hospitals and clinics across India.
          </p>

          {/* Form or Success */}
          {submitted ? (
            <div style={{
              background: "#f0fdf8", border: "1px solid #2ab4a0",
              borderRadius: "16px", padding: "32px 28px"
            }}>
              <CheckCircle2 size={44} style={{ color: "#2ab4a0", margin: "0 auto 12px" }} />
              <h3 style={{ color: "#1a3a6b", fontWeight: 700, fontSize: "20px", marginBottom: "8px" }}>
                You're on the list!
              </h3>
              <p style={{ color: "#718096", fontSize: "14px", lineHeight: 1.6 }}>
                We've sent a welcome email to <strong style={{ color: "#1a3a6b" }}>{email}</strong>.<br />
                We'll notify you the moment we launch.
              </p>
            </div>
          ) : (
            <div style={{
              background: "#fafafa", border: "1px solid #dfe3e8",
              borderRadius: "16px", padding: "28px"
            }}>
              <p style={{ color: "#1a3a6b", fontWeight: 700, fontSize: "15px", marginBottom: "4px", textAlign: "left" }}>
                Join the waitlist
              </p>
              <p style={{ color: "#718096", fontSize: "13px", marginBottom: "20px", textAlign: "left" }}>
                Be the first to know when we launch.
              </p>

              <form onSubmit={handleSubmit}>
                {/* Name */}
                <div style={{ marginBottom: "12px" }}>
                  <input
                    type="text"
                    required
                    placeholder="Your full name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    style={{
                      width: "100%", boxSizing: "border-box",
                      border: "1.5px solid #dfe3e8", borderRadius: "10px",
                      padding: "12px 16px", fontSize: "14px", color: "#1a1f2e",
                      outline: "none", background: "#fff",
                      transition: "border-color 0.2s"
                    }}
                    onFocus={e => e.target.style.borderColor = "#1a3a6b"}
                    onBlur={e => e.target.style.borderColor = "#dfe3e8"}
                  />
                </div>

                {/* Email */}
                <div style={{ marginBottom: "16px" }}>
                  <input
                    type="email"
                    required
                    placeholder="Email address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    style={{
                      width: "100%", boxSizing: "border-box",
                      border: "1.5px solid #dfe3e8", borderRadius: "10px",
                      padding: "12px 16px", fontSize: "14px", color: "#1a1f2e",
                      outline: "none", background: "#fff",
                      transition: "border-color 0.2s"
                    }}
                    onFocus={e => e.target.style.borderColor = "#1a3a6b"}
                    onBlur={e => e.target.style.borderColor = "#dfe3e8"}
                  />
                </div>

                {/* Error */}
                {error && (
                  <div style={{
                    background: "#fef2f2", border: "1px solid #fca5a5",
                    borderRadius: "8px", padding: "10px 14px",
                    color: "#dc2626", fontSize: "13px", marginBottom: "12px",
                    textAlign: "left"
                  }}>
                    {error}
                  </div>
                )}

                {/* Submit */}
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: "100%", border: "none", cursor: loading ? "not-allowed" : "pointer",
                    background: loading ? "#a0aec0" : "linear-gradient(135deg, #1a3a6b 0%, #2ab4a0 100%)",
                    color: "#ffffff", fontWeight: 700, fontSize: "15px",
                    padding: "14px", borderRadius: "10px",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                    transition: "opacity 0.2s"
                  }}
                  onMouseEnter={e => { if (!loading) e.currentTarget.style.opacity = "0.9"; }}
                  onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
                >
                  {loading
                    ? <><Loader size={16} style={{ animation: "spin 1s linear infinite" }} /> Joining...</>
                    : <>Notify Me at Launch <ArrowRight size={16} /></>
                  }
                </button>
              </form>

              <p style={{ color: "#a0aec0", fontSize: "12px", marginTop: "14px" }}>
                No spam. We only email you when we launch.
              </p>
            </div>
          )}
        </div>

        {/* ── Survey section ── */}
        <div style={{ width: "100%", maxWidth: "680px", marginTop: "64px" }}>

          {/* Divider with label */}
          <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "32px" }}>
            <div style={{ flex: 1, height: "1px", background: "#dfe3e8" }} />
            <span style={{
              fontSize: "12px", fontWeight: 700, letterSpacing: "0.08em",
              textTransform: "uppercase", color: "#2ab4a0", whiteSpace: "nowrap"
            }}>
              Help Us Build TheHealthHire
            </span>
            <div style={{ flex: 1, height: "1px", background: "#dfe3e8" }} />
          </div>

          {/* Heading + subtext */}
          <div style={{ textAlign: "center", marginBottom: "28px" }}>
            <h2 style={{ color: "#1a3a6b", fontSize: "clamp(20px, 4vw, 26px)", fontWeight: 800, marginBottom: "10px" }}>
              Tell Us What You Need
            </h2>
            <p style={{ color: "#718096", fontSize: "15px", lineHeight: 1.7, maxWidth: "480px", margin: "0 auto" }}>
              We're building TheHealthHire for healthcare professionals like you. A quick survey helps us prioritise the features that matter most.
            </p>
          </div>

          {/* Google Form embed */}
          <div style={{
            borderRadius: "16px", overflow: "hidden",
            border: "1px solid #dfe3e8", background: "#fff",
            boxShadow: "0 2px 12px rgba(26,58,107,0.06)"
          }}>
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSeI8tmON8ULsKGWnZArd7b__L2vpnvMuX9A96WduTwVOg1cDA/viewform?embedded=true"
              width="100%"
              height="2282"
              style={{ border: "none", display: "block" }}
              title="TheHealthHire User Survey"
            >
              Loading survey…
            </iframe>
          </div>

        </div>
      </div>

      {/* Footer */}
      <div style={{ borderTop: "1px solid #dfe3e8", padding: "16px", textAlign: "center", background: "#ffffff" }}>
        <p style={{ color: "#a0aec0", fontSize: "12px", margin: 0 }}>
          © 2026 TheHealthHire.com · Connecting Healthcare and Talent ·{" "}
          <a href="mailto:contact-us@thehealthhire.com"
            style={{ color: "#1a3a6b", textDecoration: "none" }}>
            contact-us@thehealthhire.com
          </a>
        </p>
      </div>

      {/* Bottom accent bar */}
      <div style={{ height: "6px", background: "linear-gradient(90deg, #1a3a6b 0%, #2ab4a0 100%)" }} />

      {/* Inline keyframes */}
      <style>{`
        @keyframes ping {
          0% { transform: scale(1); opacity: 1; }
          75%, 100% { transform: scale(1.8); opacity: 0; }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
